module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Godown/Godown.component.css
// module id = ./src/app/Godown/Godown.component.css
// module chunks = main